<div class="login-page m-0-auto ">

    <img src="assets/img/default.jpg" alt="" sizes="" srcset="" class="d-block mx-auto">

</div>